import {
    HorizAlignment,
    ISearch, ISearchProfile, ISearchProvider, ISearchProviderField,
    ISearchRequestSubset, SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch, ISearchRequest} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

var vUI_Setting_Type_Search_Fields: {[id:string]: ISearchProviderField } = {

    WB_SETTINGM_ID:       {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Id', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
    SETTING_TYPE_ID:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Id', columnResourceName: 'colId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    SETTING_TYPE_NAME:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Name', columnResourceName: 'colName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    SETTING_TYPE_DESCRIPTION:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Description', columnResourceName: 'colDescription', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 1333}},
    SETTING_UI_TREE_LOCATION:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Tree Location', columnResourceName: 'colTreeLocation', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    SOURCE_POLICY:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Source Policy', columnResourceName: 'colSourcePolicy', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    CUST_POLICY:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Customer Policy', columnResourceName: 'colCustomerPolicy', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    CUSTOMER_TYPE:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Customer Type', columnResourceName: 'colCustomerType', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    PRDGRP_POLICY:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Product Group Policy', columnResourceName: 'colProductGroupPolicy', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    PRDGRP_LEVEL_ID:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Product Group Level', columnResourceName: 'colProductGroupLevel', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    DOMAIN_POLICY:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Domain Policy', columnResourceName: 'colDomainPolicy', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    WB_DOM_ID:       {type: SearchProviderFieldType.number, renderOptions: { columnName: 'DOM Id', columnResourceName: 'colDOMId', alignment: HorizAlignment.Center}, domainOptions: {}},
    EFFECTIVE_DATE_POLICY:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Effective Date Policy', columnResourceName: 'colEffectiveDatePolicy', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    SETTING_VALUE_POLICY:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Setting Value', columnResourceName: 'colSettingValue', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    NUMBER_VALUE_MIN:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Min Value', columnResourceName: 'colMinValue', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    NUMBER_VALUE_MAX:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Max Value', columnResourceName: 'colMaxValue', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    NUMBER_FORMAT:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Number Format', columnResourceName: 'colNumberFormat', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 20}}

}

var SettingTypeSearchProviderBasic: ISearchProvider = {

    keyFields: {id:    'WB_SETTINGM_ID',
        id_ui: 'SETTING_TYPE_ID',
        name:  'SETTING_TYPE_NAME'},

    searchProviderFields: vUI_Setting_Type_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_SettingType_Search',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }

}


var SettingTypeSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "SettingTypeSearchProfileByName" },

    profileFilter: [
        {profileFilterName: 'Id',     searchProviderFieldId: 'SETTING_TYPE_ID', renderOptions: { }},
        {profileFilterName: 'Name',     searchProviderFieldId: 'SETTING_TYPE_NAME', renderOptions: { }}
    ],  // ISearchFields
    profileDisplayFields: [
        'SETTING_TYPE_ID','SETTING_TYPE_NAME','SETTING_TYPE_DESCRIPTION'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: SettingTypeSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}


var SettingTypeSearch: ISearch = {
    searchName: "Find SettingType",
    renderOptions: { ui5ResourceId: "SettingTypeSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [SettingTypeSearchProfileByName]
}
PAEnvironment.registerBusinessObjectSearch("SettingTypeBO", "SettingType", SettingTypeSearch, "Setting Type Search")

export {SettingTypeSearch}